import script from "./SplashScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./SplashScreen.vue?vue&type=script&lang=ts&setup=true"

import "./SplashScreen.vue?vue&type=style&index=0&id=1c584f81&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c584f81"]])

export default __exports__